import {SurveyDefinitionModel} from "data/models/survey";
import {ChoiceValue} from "data/models/survey/choice-base";
import {
  HopesAspirationsGoalsTitle,
  PainsAndGainsDescription_Paragraph2
} from "components/Survey/survey-sections-rendering-components/ClientAttributesTitles";
import keyMessagesChoiceListsSheet from "data/definition/surveys/key-messages-choice-lists";
import {choiceValueMap} from "helpers/choice-values";

export const HOPES_ASPIRATIONS_GOALS_CHOICES_MAP = choiceValueMap(keyMessagesChoiceListsSheet["hopes-aspirations-goals"]);

export const PAINS_FEARS_IRRITATIONS_MAP = choiceValueMap(keyMessagesChoiceListsSheet["pains-fears-irritations"]);

export const CUSTOMERS_CLIENTS_DESCRIBED: ChoiceValue[] = [
  {key: "fun", value: "fun"},
  {key: "sporty", value: "sporty"},
  {key: "stressed-out", value: "stressed out"},
  {key: "health-conscious", value: "health conscious"},
  {key: "design-focused", value: "design focused"},
  {key: "sophisticated", value: "sophisticated"},
  {key: "adventurous", value: "adventurous"},
  {key: "tech-savvy", value: "tech savvy"},
  {key: "high-energy", value: "high energy"},
  {key: "progressive", value: "progressive"},
  {key: "cautious", value: "cautious"},
  {key: "environmentally-conscious", value: "environmentally conscious"},
  {key: "picky", value: "picky"},
  {key: "time-crunched", value: "time crunched"},
  {key: "focused", value: "focused"},
  {key: "frugal", value: "frugal"},
  {key: "detail-oriented", value: "detail oriented"},
  {key: "community-focused", value: "community focused"},
  {key: "risk-takers", value: "risk takers"},
  {key: "risk-averse", value: "risk averse"},
  {key: "eager-to-try-new-things", value: "eager to try new things"},
  {key: "trendy", value: "trendy"},
  {key: "foodie", value: "foodie"},
  {key: "results-driven", value: "results driven"},
  {key: "want-work-life-balance", value: "want work/life balance"},
  {key: "family-focused", value: "family focused"},
  {key: "loving", value: "loving"},
  {key: "loves-to-shop", value: "loves to shop"},
  {key: "paranoid", value: "paranoid"},
  {key: "has-disposable-income", value: "has disposable income"},
  {key: "nature-outdoors-lover", value: "nature/outdoors lover"},
  {key: "youthful", value: "youthful"},
  {key: "thinkers", value: "thinkers"},
  {key: "want-to-save-money", value: "want to save money"},
  {key: "want-to-make-more-money", value: "want to make more money"},
  {
    key: "lack-the-knowledge-or-expertise-to-handle-their-problem",
    value: "lack the knowledge or expertise to handle their problem"
  },
  {key: "want-to-feel-good", value: "want to feel good"},
  {key: "want-to-help-others", value: "want to help others"},
  {key: "want-to-improve-their-health-or-well-being", value: "want to improve their health or well-being"},
  {key: "care-about-their-appearance", value: "care about their appearance"},
  {key: "want-things-to-be-easier", value: "want things to be easier"},
  {key: "want-to-splurge-on-a-treat", value: "want to splurge on a treat"},
  {key: "perfectionists", value: "perfectionists"},
  {key: "want-the-best-or-premium-options", value: "want the best or premium options"},
  {key: "need-to-feel-safe", value: "need to feel safe"},
  {key: "patriotic", value: "patriotic"},
  {key: "outdated-technology", value: "outdated technology"},
  {key: "lack-of-good-processes", value: "lack of good processes"},
  {key: "skeptical-of-technology", value: "skeptical of technology"},
  {key: "want-something-new", value: "want something new"},
  {key: "want-to-save-time", value: "want to save time"},
];

export const YOUR_CUSTOMERS: SurveyDefinitionModel = {
  id: "your-customers",
  surveyQuestions: [
    {
      id: "your-customers",
      title: "Your customers",
      description: null,
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "center",
        paragraphs: [
          "Your brand isn’t all about you." +
          " Your website and marketing messages must quickly show potential customers that you understand them," +
          " their challenges, and their aspirations." +
          " They need to feel confident that your business or product can help them solve their problems," +
          " reach their goals, or make them happy.",
          "Now you’re going to answer questions about who is most likely to buy from you—your ideal clients." +
          " Once we understand who they are and what they want," +
          " Branding Compass will make recommendations on the best words and tone to attract your ideal customers.",
        ],
      },
    },
    {
      id: "pains-and-gains-intro",
      title: "Pains and gains",
      description: null,
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "center",
        paragraphs: [
          "It’s human nature that people want to move away from their pains" +
          " and toward situations that make them feel better.",
          PainsAndGainsDescription_Paragraph2,
          "Depending on the type of business you have," +
          " your customers may have both pains and gains," +
          " or most of your answers may be in one area or the other." +
          " Consumer products, especially luxury ones," +
          " tend to pull more on aspirations than pains." +
          " Professional service businesses usually have both."
        ],
      },
    }, {
      id: "pains-fears-irritations",
      title: "What are the typical pains, fears or irritations your customers are experiencing?",
      description: "Your customers and prospects are…",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: null,
        otherInputBox: false,
        choices: keyMessagesChoiceListsSheet["pains-fears-irritations"],
      },
    }, {
      id: "hopes-aspirations-goals",
      title: HopesAspirationsGoalsTitle,
      description: "Your customers and prospects want…",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: null,
        otherInputBox: false,
        choices: keyMessagesChoiceListsSheet["hopes-aspirations-goals"],
      },
    }, {
      id: "customers-clients-described",
      title: "How would you describe your customers or clients?",
      description: null,
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: null,
        otherInputBox: true,
        choices: CUSTOMERS_CLIENTS_DESCRIBED,
      },
    }, {
      id: "ranked-client-attributes",
      title: "Rank these client attributes.",
      description: "What do your best customers have in common? Put the most common attributes at the top. Choose up to 5.",
      kind: "rank-order",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        maxResultCount: 5,
        choicesSources: [
          "pains-fears-irritations",
          "hopes-aspirations-goals",
          "customers-clients-described",
        ],
      },
    },
  ],
}
